import moment from "moment";

type Options = {
	date: string; // The date as a string input
	format: "DD/MM/YYYY" | "YYYY-MM-DD" | "DD/MM/YYYY HH:mm"; // Supported date formats
};

export default function formatDate({ date, format }: Options) {
	if (!date) {
		return "";
	}

	return moment(date).format(format);
}
